import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=bebfab1e&scoped=true"
import script from "./SimpleTable.vue?vue&type=script&lang=js"
export * from "./SimpleTable.vue?vue&type=script&lang=js"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=bebfab1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebfab1e",
  null
  
)

export default component.exports